import Blue from "~/core";

new Blue({
	name: 'Image Swap for Screen Size',
	selector: "[data-img-lg], [data-img-sm]",
	setup(container) {
		const containerIsImg = container.matches("img");
		const imgPath = {
			sm: container.getAttribute("data-img-sm"),
			lg: container.getAttribute("data-img-lg")
		};
		const smallIsNull = !imgPath.sm || imgPath.sm == "" || imgPath.sm == "null";
		const largeIsNull = !imgPath.lg || imgPath.lg == "" || imgPath.lg == "null";

		const updateImgPath = (pathToUse) => {
			if (containerIsImg) {
				container.setAttribute("src", pathToUse);
			} else {
				container.style.backgroundImage = `url(${pathToUse})`
			}
		}

		// if both paths exist, init code to set and swap appropriately based on screen size
		if (!smallIsNull && !largeIsNull) {
			let currentWindowWidth = window.innerWidth;
			let windowHeight = window.innerHeight;
			const breakpoint = 576;

			if (currentWindowWidth < breakpoint || windowHeight < breakpoint) updateImgPath(imgPath.sm)
			else updateImgPath(imgPath.lg)
	
			this.$addEvents(window, "resize", () => {
				windowHeight = window.innerHeight;
				let newWindowWidth = window.innerWidth;
				if (
					newWindowWidth >= breakpoint && 
					currentWindowWidth < breakpoint && 
					windowHeight >= breakpoint
				) {
					updateImgPath(imgPath.lg)
				}
				else if (
					newWindowWidth < breakpoint && 
					currentWindowWidth >= breakpoint || 
					windowHeight < breakpoint
				) {
					updateImgPath(imgPath.sm)
				}
				currentWindowWidth = newWindowWidth;
			});
		} 
		// if neither path exists, do nothing
		else if (smallIsNull && largeIsNull) {
			return;
		} 
		// if only one exists, set the existing path once and leave it (no resetting on screen resize)
		else {
			let existingPath = smallIsNull ? imgPath.lg : imgPath.sm;
			updateImgPath(existingPath);
		}
	}
});